import { mainConstants, uriConstants } from '../../constants'
import { defaultService } from '../../services'
import { errorMessages } from '../../messages'
import { alertActions } from '..'

export const memberAppActions = {
  updateAlmPushYn,
  updateAutoLoginYn,
  get,
  load,
  insertDeviceId,
}

/*********
 수정
 **********/
function updateAutoLoginYn(params) {
  return async (dispatch) => {
    dispatch(apiAction(mainConstants.MAIN_LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.UPDATE_PTL_MEMBER_APP,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 푸시 수신동의 여부
 **********/
function updateAlmPushYn(params) {
  return async (dispatch) => {
    dispatch(apiAction(mainConstants.MAIN_LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.UPDATE_PTL_ALMPUSH_YN,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 get
 **********/
function get(params) {
  return async (dispatch) => {
    dispatch(apiAction(mainConstants.MAIN_LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.GET_PTL_MEMBER_APP,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/*********
 알림함
 **********/
function load() {
  return async (dispatch) => {
    dispatch(apiAction(mainConstants.MAIN_LOAD_REQUEST))

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.GET_PUSH_LIST,
      })
      .then(
        (response) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = { type }
  response && (resultObj.response = response)
  return resultObj
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}

/**
 * 디바이스 아이디 없으면 insert
 * @param {String} deviceId
 * @returns
 */
function insertDeviceId(deviceId) {
  return (dispatch) => {
    dispatch(apiAction(mainConstants.APP_ACCESS_LOAD_REQUEST))

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.INSERT_DEVICE_ID + '/' + deviceId,
      })
      .then(
        (response) => {
          dispatch(apiAction(mainConstants.APP_ACCESS_LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(mainConstants.APP_ACCESS_LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}
